import { defineMessages } from 'react-intl.macro';

export default defineMessages({
  filters: {
    id: 'core.AvailabilitySelector.filters',
    defaultMessage: 'Filters',
  },
  facilities: {
    id: 'core.AvailabilitySelector.facilities',
    defaultMessage: 'Facilities',
  },
  apptTypes: {
    id: 'core.AvailabilitySelector.appointmentType',
    defaultMessage: 'Appointment Types',
  },
  providers: {
    id: 'core.AvailabilitySelector.providers',
    defaultMessage: 'Providers',
  },
  timeZone: {
    id: 'core.AvailabilitySelector.TimeZoneSelector.timeZone',
    defaultMessage: 'Time zone',
  },
  distance: {
    id: 'core.AvailabilitySelector.TimeZoneSelector.distance',
    defaultMessage: 'Distance',
  },
});
